/* unplugin-vue-components disabled */import script from "./Google.vue?vue&type=script&setup=true&lang=ts"
export * from "./Google.vue?vue&type=script&setup=true&lang=ts"

import "./Google.vue?vue&type=style&index=0&id=b419f62e&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b419f62e"]])

export default __exports__